import React, {
  PropTypes as T,
} from 'react';
import radium from 'radium';

const colors = ['#990013', '#D0021B', '#F5A623', '#FED312', '#FFE951', '#FFF29A'];

const styles = {
  wrap: {
    width: 10,
    height: 'auto',
  },
};

function LevelBar(props) {
  const level = props.level;

  return (
    <div style={styles.wrap}>
      {Array.apply(null, { length: colors.length }).map((n, idx) => {
        let color = 'white';
        if (colors.length - idx <= level) {
          color = colors[idx];
        }
        return (
          <div
            style={{ backgroundColor: color,
                     width: 10,
                     height: 24,
                     margin: '3px 0px' }}
            key={idx}></div>
         );
      })}
    </div>
  );
}

LevelBar.propTypes = {
  level: T.number,
};

export default radium(LevelBar);



// WEBPACK FOOTER //
// ./components/LevelBar.js